<!--首页-->
<template>
  <div class="main">
    <div id='roll-point-top' style="height: 0px;width: 1px"></div>
    <!--    头部-->
    <div class="header">
      <Header
        :headerMenuSelectedKey="headerMenuSelectedKey"
        :shrinkMenuSelectedKey="subMenuSelectedKey"/>
    </div>
    <!--    banner图-->
    <div class="banner">
      <div class="item">
        <img :src="dataList[currentIndex]">
      </div>
      <div class="page" v-if="this.dataList.length > 1">
        <ul>
          <li @click="gotoPrev" class="pre">&lt;</li>
          <li @click="gotoNext" class="next">&gt;</li>
        </ul>
      </div>
    </div>
    <!--    内容-->
    <div class="content">
      <div class="brand">
        <div class="service-brand">
          <h2>我们服务过的品牌</h2>
          <ul>
            <li><img class="li" src="../../static/image/home/logo/logo01.jpg"/></li>
            <li><img class="li" src="../../static/image/home/logo/logo02.jpg"/></li>
            <li><img class="li" src="../../static/image/home/logo/logo03.jpg"/></li>
            <li><img class="li" src="../../static/image/home/logo/logo04.jpg"/></li>
            <li><img class="li" src="../../static/image/home/logo/logo05.jpg"/></li>
            <li><img class="li" src="../../static/image/home/logo/logo06.jpg"/></li>
            <li><img class="li" src="../../static/image/home/logo/logo07.jpg"/></li>
            <li><img class="li" src="../../static/image/home/logo/logo08.jpg"/></li>
            <li><img class="li" src="../../static/image/home/logo/logo09.jpg"/></li>
            <li><img class="li" src="../../static/image/home/logo/logo10.jpg"/></li>
            <li><img class="li" src="../../static/image/home/logo/logo11.jpg"/></li>
            <li><img class="li" src="../../static/image/home/logo/logo12.jpg"/></li>
            <li><img class="li" src="../../static/image/home/logo/logo13.jpg"/></li>
            <li><img class="li" src="../../static/image/home/logo/logo14.jpg"/></li>
            <li><img class="li" src="../../static/image/home/logo/logo15.jpg"/></li>
          </ul>
        </div>
        <!--        市场营销-->
        <div class="market" @click="goPage()">
          <div class="circleIcon">
          </div>
          <div class="market-content">
            <h2>市场营销</h2>
            <p>专注提供品牌宣传、PPT美化、社交平台、App开发和线上线下活动策划等服务，提供清晰定位于市场部需求的专业数字媒体创意服务</p>
          </div>
        </div>
        <!--        医学事务-->
        <div class="medical-science" @click="goPage()">
          <div class="circleIcons">
          </div>
          <div class="medical-science-content">
            <h2>医学事务</h2>
            <p>具备丰富的医患沟通、医者赋能、医学公益和健康信息可视化能力，更好的帮助现代医学事务部门解析和传递产品医学及健康价值。</p>
          </div>
        </div>
        <!--        研发事务-->
        <div class="medical-science" @click="goPage()">
          <div class="circleIconYf">
          </div>
          <div class="medical-science-content">
            <h2>研发事务</h2>
            <p>通过创意和媒体赋能，更好的传递创新进展和潜在价值，为科研讲者提供更具备感染力的演讲PPT，开发专业的网站和App，助力数字健康和医疗服务创新。</p>
          </div>
        </div>
        <!--        销售事务-->
        <div class="medical-science" @click="goPage()">
          <div class="circleIconXs">
          </div>
          <div class="medical-science-content">
            <h2>销售事务</h2>
            <p>提供销售工具数字化设计，以更高效清晰的方式传递信息，通过提供产品和舆情检测，更好的把握商机，协助公司高效完成招投标准备工作。</p>
          </div>
        </div>
        <!--        供应链事务-->
        <div class="medical-science" @click="goPage()">
          <div class="circleIconGyl">
          </div>
          <div class="medical-science-content">
            <h2>供应链事务</h2>
            <p>协助生产环境导视系统开发，提高内部职业健康及安全管理体系设计、支持线上线下产品质量宣传活动。</p>
          </div>
        </div>
      </div>
      <!--    理想与口碑-->
      <div class="ideal">
        <h1>我们的理念与口碑</h1>
        <div class="line">
          <div class="line-left"></div>
          <div class="line-right"></div>
        </div>
        <div class="ideal-content">
          <img src="static/image/home/ysln.jpg" class="ideal-left-img"/>
          <div class="ideal-content-right">
            <div class="artistic">福玳的创意理念</div>
            <p>
              数字健康时代的到来，改变了传统医疗健康行业的生态与基调。医疗健康品牌的价值体现，已经不再局限于产品的生物学、医学参数本身，而是拓展到这个品牌的产品如何能智能的、个性化的为用户健康保驾护航。福玳可以帮助品牌和产品加深与用户的沟通、提供个性化的健康方案、增强产品的功能和体感，让用户确实体验到使用后的改变，从而进一步提高产品依从性并加强对品牌传递理念的认同。
              <br>
              福玳，能帮助您轻松顺应数字化的潮流，将品牌文化、价值观、健康理念传播到每一位用户！</p>
            <div class="opinions">客户口碑</div>
            <div class="opinions-content">
              <p class="content-index">{{ a.index }}</p>
              <p class="content-name">{{ a.name }}</p>
            </div>
            <div class="arrow-btn">
              <img src="static/image/home/u189.svg" class="arrow-left" @click="prev()"/>
              <img src="static/image/home/u189.svg" class="arrow-right" @click="next()"/>
            </div>
          </div>
        </div>
      </div>
      <!--    代表作品-->
      <div class="representative-box">
        <h1>我们的部分代表作品</h1>
        <div class="line">
          <div class="line-left"></div>
          <div class="line-right"></div>
        </div>
        <div class="representative">
          <div class="img_div" @click="checkDetails">
            <img src="static/image/solution/GE-PC.jpg" class="img-div-img">
            <a href="#">
              <div class="mask">
                <h3>GE京东</h3>
                <p>GE京东网站设计与开发—PC端</p>
              </div>
            </a>
          </div>
          <div class="img_div" @click="checkDetails">
            <img src="static/image/solution/haisen-2.jpg" class="img-div-img">
            <a href="#">
              <div class="mask">
                <h3>海森生物</h3>
                <p>海森生物官方微信设计与维护</p>
              </div>
            </a>
          </div>
          <div class="img_div" @click="checkDetails">
            <img src="static/image/solution/lvgu.jpg" class="img-div-img">
            <a href="#">
              <div class="mask">
                <h3>绿谷制药</h3>
                <p>绿谷制药节气热点海报</p>
              </div>
            </a>
          </div>
          <div class="img_div" @click="checkDetails">
            <img src="static/image/solution/ppsj-hssw.jpg" class="img-div-img">
            <a href="#">
              <div class="mask">
                <h3>海森生物LOGO</h3>
                <p>品牌LOGO设计</p>
              </div>
            </a>
          </div>
          <div class="img_div" @click="checkDetails">
            <img src="static/image/solution/yssj-pa.jpg" class="img-div-img">
            <a href="#">
              <div class="mask">
                <h3>平安好医</h3>
                <p>平安好医宣传演示设计</p>
              </div>
            </a>
          </div>
          <div class="img_div" @click="checkDetails">
            <img src="static/image/solution/spcy-shxyd.jpg" class="img-div-img">
            <a href="#">
              <div class="mask">
                <h3>上海信易贷</h3>
                <p>上海信易贷宣传视频</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--    企业微信-->
    <div class="enterpriseWechat">
      <EnterpriseWechat/>
    </div>
    <!--    尾部-->
    <div class="footer">
      <Footer
        :headerMenuSelectedKey="headerMenuSelectedKey"
        :shrinkMenuSelectedKey="subMenuSelectedKey"/>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import EnterpriseWechat from "../components/EnterpriseWechat"

export default {
  components: {EnterpriseWechat, Header, Footer},
  data() {
    return {
      headerMenuSelectedKey: 'home',
      subMenuSelectedKey: '',
      arr: [
        {
          index: '医疗企业品牌的主视觉创意一直是一个难题，福玳的创意团队提出了新颖的想法，耐心的与我们沟通并仔细聆听每一轮创意的消费者的反馈，帮助我们捕捉到了重要的核心诉求。在这个基础上开展的双微平台推广和宣传中，我的品牌取得了非常好成绩，市场份额稳步上升 ',
          name: '- 强生品牌市场部 王总'
        },
        {
          index: '福玳开发的小程序简单易用，很好的解决了我们团队收集用户使用产品后反馈信息收集的难题！谢谢你们！',
          name: '- 雅培营养品医学团队 赵总'
        },
        {
          index: '福玳的UX/UI（用户体验/用户互动界面）创意方案完美的解决了我们在数字疗法开发中所面临的视觉挑战，显著提高了用户对我们的数字化产品的接受度和依从性！',
          name: '- 强生数字疗法开发团队 张总'
        },
        {
          index: '福玳的设计师非常专业，不仅具备高水平的创意设计能力，而且对于医疗健康领域终端用户需求具有丰富的经验和敏锐的洞察，在数字医疗产品项目合作过程中，能够准确、充分理解项目的设计需求，并能够积极配合客户反馈进行灵活调整，快速给出多种高质量、创新的设计方案，满足项目需求。对接客户的项目管理人员具有很强的沟通协作能力，能够积极与项目开发团队配合，确保设计内容的交付和后续执行。    ',
          name: '- 强生数字医疗团队  张经理'
        }
      ],
      a: 1,
      i: 2,
      dataList: ["static/image/home/banner1.jpg", "static/image/home/banner2.jpg", "static/image/home/banner3.jpg", "static/image/home/banner4.jpg"],
      currentIndex: 0,   //默认显示图片
    };
  },
  watch: {},
  created() {
    this.a = this.arr[this.i % (this.arr.length)]
  },
  mounted() {
    document.title = "首页";
    document.documentElement.scrollTop = 0
    this.gotoPage()
  },
  methods: {
    goPage() {
      this.$router.push({path: '/Service'})
    },
    checkDetails(e) {
      this.$router.push({path: '/CaseDisplay'})
    },
    prev() {
      this.i--
      this.a = this.arr[this.i % (this.arr.length)]
    },
    next() {
      this.i++
      this.a = this.arr[this.i % (this.arr.length)]
    },
    gotoPrev() {
      this.currentIndex--
    },
    gotoNext() {
      this.currentIndex++;
      if (this.currentIndex == this.dataList.length) {
        this.currentIndex = 0;
      }
    },
    gotoPage() {
      setInterval(() => {
        this.gotoNext()
      }, 3000)
    },
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(249, 249, 249, 1);
}

.header {
  width: 1920px;
  height: 60px;
}

.enterpriseWechat {
  position: fixed;
  top: 45%;
  right: 0;
}

.banner {
  width: 100%;
  margin: 0 auto;
  position: relative;
}

.banner img {
  width: 100%;
  display: block;
}

.banner .page {
  /*background: rgba(0, 0, 0, .5);*/
  color: #ffffff;
  letter-spacing: 20px;
  position: absolute;
  right: 0;
  bottom: 50%;
  width: 100%;
}

.banner .page ul {
  display: flex;
  justify-content: center;
  align-content: center;
}

.pre {
  position: absolute;
  left: 10px;
  font-size: 30px;
}

.next {
  position: absolute;
  right: 0;
  font-size: 30px;
}

.content {
  width: 1400px;
  height: auto;
  margin-top: 40px;
}

.brand {
  width: 100%;
  height: 500px;
}

.service-brand {
  width: 30%;
  height: 456px;
  box-shadow: 1px 1px 10px rgb(0 0 0 / 20%);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  float: left;
}

.service-brand h2 {
  font-size: 22px;
  color: #D1121C;
}

.service-brand ul {
  float: left;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.service-brand ul li {
  width: 33%;
  height: 69px;
  float: left;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.service-brand ul li img {
  filter: grayscale(100%);
  opacity: 0.8;
}

.li1 {
  width: 87px;
  height: 83px;
}

.li {
  width: 125px;
  height: 70px;
}

.li2 {
  width: 79px;
  height: 28px;
}

.li3 {
  width: 80px;
  height: 20px;
}

.service-brand ul li img:hover {
  filter: none;
  opacity: 1;
}

.market {
  width: 68%;
  height: 139px;
  box-shadow: 1px 1px 10px rgb(0 0 0 / 20%);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  float: right;
}

.circleIcon {
  width: 80px;
  height: 80px;
  background-image: url("../../static/image/icon/scyx-red.png");
  background-size: 80px 80px;
}

.market-content {
  width: 80%;
}

.market-content h2 {
  color: #D1121C;
  font-size: 18px;
}

.market-content p {
  font-size: 13px;
  margin-top: 10px;
}

.market:hover {
  background: #D1121C;
  color: #FFFFFF;
}

.market:hover h2 {
  color: #FFFFFF;
}

.market:hover .circleIcon {
  width: 80px;
  height: 80px;
  background-image: url("../../static/image/icon/scyx-white.png");
  background-size: 80px 80px;
}

.medical-science {
  width: 33%;
  height: 139px;
  box-shadow: 1px 1px 10px rgb(0 0 0 / 20%);
  border-radius: 15px;
  display: flex;
  align-items: center;
  float: left;
  margin-left: 2%;
  margin-top: 20px;
  padding: 35px;
}

.medical-science-content {
  width: 80%;
}

.medical-science .circleIcons {
  width: 80px;
  height: 80px;
  background-image: url("../../static/image/icon/yxsw-red.png");
  background-size: 80px 80px;
}

.medical-science .circleIconYf {
  width: 80px;
  height: 80px;
  background-image: url("../../static/image/icon/yfsw-red.png");
  background-size: 80px 80px;
}

.medical-science .circleIconXs {
  width: 80px;
  height: 80px;
  background-image: url("../../static/image/icon/xssw-red.png");
  background-size: 80px 80px;
}

.medical-science .circleIconGyl {
  width: 80px;
  height: 80px;
  background-image: url("../../static/image/icon/gylsw-red.png");
  background-size: 80px 80px;
}

.medical-science-content h2 {
  color: #D1121C;
  font-size: 18px;
  /*text-align: center;*/
  margin-left: 35px;
}

.medical-science-content p {
  font-size: 13px;
  margin-top: 10px;
  width: 80%;
  margin-left: 35px;
}

.medical-science:hover {
  background: #D1121C;
  color: #FFFFFF;
}

.medical-science:hover h2 {
  color: #FFFFFF;
}

.medical-science:hover .circleIcons {
  width: 80px;
  height: 80px;
  background-image: url("../../static/image/icon/yxsw-white.png");
  background-size: 80px 80px;
}

.medical-science:hover .circleIconYf {
  width: 80px;
  height: 80px;
  background-image: url("../../static/image/icon/yfsw-white.png");
  background-size: 80px 80px;
}

.medical-science:hover .circleIconXs {
  width: 80px;
  height: 80px;
  background-image: url("../../static/image/icon/xssw-white.png");
  background-size: 80px 80px;
}

.medical-science:hover .circleIconGyl {
  width: 80px;
  height: 80px;
  background-image: url("../../static/image/icon/gylsw-white.png");
  background-size: 80px 80px;
}

.ideal {
  width: 100%;
  height: 900px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.ideal h1 {
  color: #D1121C;
  font-size: 34px;
  text-align: center;
}

.line {
  margin-top: 20px;
}

.line-left {
  width: 37px;
  height: 8px;
  background: #D1121C;
  border-radius: 10px;
  float: left;
}

.line-right {
  width: 119px;
  height: 8px;
  background: #D1121C;
  border-radius: 10px;
  float: left;
  margin-left: 10px;
}

.ideal-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ideal-content-right {
  width: 60%;
  margin-top: 50px;
}

.ideal-left-img {
  width: 510px;
  height: 676px;
  margin-top: 50px;
  float: left;
}

.artistic {
  width: 227px;
  height: 46px;
  background: #D1121C;
  border-radius: 6px;
  color: #FFFFFF;
  font-size: 22px;
  text-align: center;
  line-height: 46px;
}

.ideal-content-right p {
  font-size: 16px;
  margin-top: 30px;
  margin-bottom: 50px;
}

.opinions {
  width: 117px;
  height: 46px;
  background: #D1121C;
  border-radius: 6px;
  color: #FFFFFF;
  font-size: 22px;
  text-align: center;
  line-height: 46px;
}

.opinions-content {
  width: 100%;
  height: 289px;
  background: #ffffff;
  border-radius: 10px;
  margin-top: 30px;
  padding: 30px;
 overflow: hidden;
}

.opinions-content p {
  font-size: 16px;
}

.content-name {
  float: right;
}

.arrow-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  float: right;
}

.arrow-left {
  width: 23px;
  height: 23px;
  transform: rotate(180deg);
}

.arrow-right {
  width: 23px;
  height: 23px;
  margin-left: 20px;
}

.representative-box {
  width: 100%;
  height: 1050px;
  margin-bottom: 100px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.representative-box h1 {
  color: #D1121C;
  font-size: 34px;
  text-align: center;
}

.representative {
  width: 100%;
  height: 1000px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 50px;
}

.img_div {
  position: relative;
  width: 450px;
  height: 450px;
}

.img-div-img {
  width: 450px;
  height: 450px;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 450px;
  height: 450px;
  background: rgba(209, 18, 28, 0.8);
  color: #ffffff;
  opacity: 0;
}

.mask h3 {
  font-size: 26px;
  color: #FFFFFF;
  margin-top: 350px;
  margin-left: 20px;
}

.mask p {
  color: #FFFFFF;
  margin-left: 20px;
}

.img_div a:hover .mask {
  transition: 200ms;
  opacity: 1;
}

.footer {
  height: 189px;
  width: 1920px;
  overflow: hidden;
  position: relative;
  bottom: 0;
}


</style>





// WEBPACK FOOTER //
// src/views/Home.vue